import { Link } from 'react-router-dom';
import { useUiStore } from '../../store';
import { STRINGS } from '../../i18n';
import { Wizard } from './Wizard';

/**
 * Top-level RefundRocket page. Shows a hero, the wizard, and a footer
 * note explaining the tool's scope.
 */
export function Calculator() {
  const locale = useUiStore((s) => s.locale);
  const t = STRINGS[locale];

  return (
    <main className="px-6 py-12 sm:py-16">
      <div className="mx-auto max-w-3xl">
        <div className="text-center">
          <p className="text-sm font-medium uppercase tracking-wide text-brand-600">
            RefundRocket
          </p>
          <h1 className="mt-2 text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl">
            Estimate your US federal tax refund
          </h1>
          <p className="mt-3 text-base text-slate-500 sm:text-lg">
            5 steps, no login, no data leaves your browser.
          </p>
        </div>

        <div className="mt-10">
          <Wizard />
        </div>

        <p className="mt-10 text-center text-xs text-slate-400">
          <Link to="/" className="hover:text-slate-700">
            ← {t.backHome}
          </Link>
        </p>
      </div>
    </main>
  );
}

export default Calculator;